const setUpdateCount = ({ commit }) => {
    commit('setUpdateCountMutation');
};

const setTotal = ({ commit }, payload) => {
    commit('setTotalMutation', payload);
};

const setRate = ({ commit }, payload) => {
    commit('setRateMutation', payload);
};

const setSecondYearTotal = ({ commit }, payload) => {
    commit('setTotalMutation', payload);
};

const setSecondYearRate = ({ commit }, payload) => {
    commit('setRateMutation', payload);
};

const setData = ({ dispatch, commit }, { key, val, suppressUpdateCount }) => {
    commit('setDataMutation', { key, val });

    // TODO: think how to dispatch setUpdateCount more convenient
    if (!suppressUpdateCount) {
        dispatch('setUpdateCount');
    }
};

const setAmount = ({ dispatch }, payload) => {
    return dispatch('setDataMutation', payload);
};

export { setUpdateCount, setTotal, setRate, setSecondYearTotal, setSecondYearRate, setData, setAmount };
